import Template from 'backbone/platform/templates/assets/asset_picker_actions.js.hamlc'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class AssetPickerActionsView extends Backbone.View
  events:
    "click .js-save"   : "pick"

  initialize: ->
    @dispatcher = BackboneDispatcher.get_instance()

  render: (opts) ->
    @$el.html Template
      formValid: opts?.formValid
      hideChoose: opts?.hideChoose

  pick: =>
    @dispatcher.trigger("assetsPicked")



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/asset_picker_actions_view.js.coffee